// Breadcrumb — miga de pan de la tienda v5 (botón "← Volver" + trail + actual).
// Fuente: maquetas. Touch target del back ≥44px. Sin estado.
//
// Self-contained: <style>{BC_CSS}</style> + clases .tv5-bc-* + tokens --tv5-* propios.
//
// Props:
//   backHref   string   → destino del botón "← Volver"
//   backLabel  string   → texto del botón (default 'Volver')
//   trail      Array<{label, href}>  → items intermedios clickeables
//   current    string   → item actual (no clickeable)
import { Link } from 'react-router-dom';

const BC_CSS = `
.tv5-bc {
  --tv5-teal:#00A8B5; --tv5-text:#F8F6F1; --tv5-muted:rgba(248,246,241,0.65);
  --tv5-dim:rgba(248,246,241,0.45); --tv5-border:rgba(255,255,255,0.08);
  max-width:1400px; margin:0 auto; padding:12px 20px 0; font-size:13px; color:var(--tv5-dim);
  display:flex; align-items:center; gap:8px; flex-wrap:wrap;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
}
.tv5-bc-back {
  display:inline-flex; align-items:center; gap:4px; color:var(--tv5-text); text-decoration:none;
  background:rgba(255,255,255,0.05); border:1px solid var(--tv5-border); padding:6px 14px;
  border-radius:999px; font-weight:600; font-size:12px; min-height:44px; transition:all 0.2s;
}
.tv5-bc-back .tv5-bc-arrow { font-size:14px; font-weight:700; line-height:1; }
.tv5-bc-sep { opacity:0.4; font-size:14px; }
.tv5-bc-item { color:var(--tv5-muted); text-decoration:none; font-weight:500; }
.tv5-bc-current { color:var(--tv5-text); font-weight:600; }
@media (hover:hover){
  .tv5-bc-back:hover { background:rgba(0,168,181,0.12); border-color:rgba(0,168,181,0.4); color:var(--tv5-teal); transform:translateX(-2px); }
  .tv5-bc-item:hover { color:var(--tv5-teal); }
}
`;

export function Breadcrumb({ backHref, backLabel = 'Volver', trail = [], current }) {
  return (
    <div className="tv5-bc">
      <style>{BC_CSS}</style>
      {backHref && (
        <Link to={backHref} className="tv5-bc-back" aria-label={'Volver a ' + backLabel}>
          <span className="tv5-bc-arrow">←</span> {backLabel}
        </Link>
      )}
      {trail.map((item, i) => (
        <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
          <span className="tv5-bc-sep">/</span>
          <Link to={item.href} className="tv5-bc-item">{item.label}</Link>
        </span>
      ))}
      {current && (
        <>
          <span className="tv5-bc-sep">/</span>
          <span className="tv5-bc-current">{current}</span>
        </>
      )}
    </div>
  );
}
